import { render, staticRenderFns } from "./NewTicketRequest.vue?vue&type=template&id=4759ed9d&scoped=true&"
import script from "./NewTicketRequest.vue?vue&type=script&lang=ts&"
export * from "./NewTicketRequest.vue?vue&type=script&lang=ts&"
import style0 from "./NewTicketRequest.vue?vue&type=style&index=0&id=4759ed9d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4759ed9d",
  null
  
)

export default component.exports